import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";

// Configure Cloudflare R2 using Environment Variables for Security
// requestChecksumCalculation + responseChecksumValidation disable the SDK's
// automatic CRC32 checksum middleware that causes CORS failures on R2.
const s3Client = new S3Client({
  region: "auto",
  endpoint: process.env.REACT_APP_R2_ENDPOINT,
  credentials: {
    accessKeyId: process.env.REACT_APP_R2_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_R2_SECRET_ACCESS_KEY,
  },
  forcePathStyle: true,
  requestChecksumCalculation: "WHEN_REQUIRED",
  responseChecksumValidation: "WHEN_REQUIRED",
});

/**
 * Strip any x-amz-checksum / x-amz-sdk-checksum query params from a URL.
 * These are injected by the AWS SDK v3 middleware and Cloudflare R2 does not
 * support them properly through CORS-preflight OPTIONS requests.
 */
function stripChecksumParams(url) {
  const u = new URL(url);
  const keysToDelete = [];
  for (const key of u.searchParams.keys()) {
    if (key.toLowerCase().startsWith("x-amz-checksum") ||
        key.toLowerCase().startsWith("x-amz-sdk-checksum")) {
      keysToDelete.push(key);
    }
  }
  keysToDelete.forEach((k) => u.searchParams.delete(k));
  return u.toString();
}

export const uploadImageToR2 = async (file) => {
  if (!file) throw new Error("No file provided");

  const fileExtension = file.name.split('.').pop();
  const rawBaseName = file.name.replace(`.${fileExtension}`, '').replace(/[^a-zA-Z0-9]/g, '_');
  const uniqueFileName = `${Date.now()}-${rawBaseName}.${fileExtension}`;
  const key = `images/${uniqueFileName}`;

  const command = new PutObjectCommand({
    Bucket: process.env.REACT_APP_R2_BUCKET_NAME,
    Key: key,
    ContentType: file.type,
  });

  try {
    let presignedUrl = await getSignedUrl(s3Client, command, { expiresIn: 3600 });

    // Safety net: strip any lingering checksum query params
    presignedUrl = stripChecksumParams(presignedUrl);

    console.log("Presigned URL (cleaned):", presignedUrl);

    // Use native fetch – avoids Axios default headers that can trigger CORS issues
    const response = await fetch(presignedUrl, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": file.type,
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("R2 Upload Error Response:", errorText);
      throw new Error(`Upload failed with status ${response.status}: ${errorText}`);
    }

    // Replace this with your actual Public R2 URL prefix from your Cloudflare dashboard
    const publicUrl = `https://pub-dbb7f1134a3a451cbd9874401824d46b.r2.dev/${key}`;
    return publicUrl;
  } catch (error) {
    console.error("Error in Presigned R2 Upload:", error);
    throw error;
  }
};
